import React from "react";
import PropTypes from "prop-types";
import styles from "./CatalogDummyImagePlaceholder.module.css";

/** Premium catalog image placeholder — light frame + subtle icon (cart drawer / upsell parity). */
export default function CatalogDummyImagePlaceholder({
  className = "",
  style,
  iconSize = "md",
}) {
  const iconClass =
    iconSize === "sm" ? styles.iconSm : iconSize === "lg" ? styles.iconLg : styles.iconMd;

  return (
    <div
      className={`${styles.root} ${className}`.trim()}
      style={style}
      aria-hidden
    >
      <svg
        className={iconClass}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          x="3.5"
          y="5"
          width="17"
          height="14"
          rx="2.5"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M7.5 15.5 10.2 12.2c.5-.6 1.4-.6 1.9 0l1.4 1.7 2.1-2.5c.5-.6 1.4-.6 1.9 0L18.5 15"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="9" cy="9.5" r="1.25" fill="currentColor" />
      </svg>
    </div>
  );
}

CatalogDummyImagePlaceholder.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  iconSize: PropTypes.oneOf(["sm", "md", "lg"]),
};
